const getUploadBaseUrl = () => {
  const envUploadBaseUrl = String(import.meta?.env?.VITE_UPLOAD_BASE_URL || "").trim();
  if (envUploadBaseUrl) {
    if (typeof window !== "undefined") {
      const hostname = window.location?.hostname;
      const isLocalHost = hostname === "localhost" || hostname === "127.0.0.1";
      const isLocalOverride = /(^|\/\/)(localhost|127\.0\.0\.1)(:|\/|$)/i.test(envUploadBaseUrl);
      if (!isLocalHost && isLocalOverride) {
        // Ignore unsafe override and fall back to hostname-based routing.
      } else {
        return envUploadBaseUrl;
      }
    } else {
      return envUploadBaseUrl;
    }
  }

  if (typeof window === "undefined") {
    return "http://localhost:3002";
  }

  const { hostname, protocol, port, origin } = window.location;

  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "http://localhost:3002";
  }

  if (
    hostname === "unmaapp.com" ||
    hostname === "www.unmaapp.com" ||
    hostname.includes("unmaapp.com")
  ) {
    return "https://www.unmaapp.com";
  }

  if (hostname === "newsworld.testatozas.in" || hostname.includes("testatozas.in")) {
    return "https://newsworld.testatozas.in";
  }

  if (port === "5173" || port === "5174") {
    return `${protocol}//${hostname}:3002`;
  }
  return origin;
};

const UPLOAD_BASE_URL = getUploadBaseUrl();
export const uploadUrl = `${UPLOAD_BASE_URL}/uploads`;
export const upload = UPLOAD_BASE_URL;
export { getUploadBaseUrl };
